<section class="aboutusrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top"  data-aos="fade-up" data-aos-delay="150">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Our Company</h3>
                            </header>                           
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>                
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-4" data-aos="fade-right" data-aos-delay="100">
                <p></p>
                <br/>
                <img  src="../../assets/images/SFI-Logo-wTagline Horizontal.png" class="img-fluid"  alt=""/><br/>
                <p></p>
                <span class="theme_color">
                    <a href="/contact" class="theme_color"><strong class="fontRed"><u>Contact us today</u></strong></a> to learn more about how SFI can improve your workplace safety program.
                </span>
            </div>
            <div class="col-lg-8" data-aos="fade-left" data-aos-delay="100" style="padding-top: 20px;">
                <h3 class="theme_color">
                    <strong class="fontRed">Beyond Compliance. Built on Excellence.</strong>.
                </h3>

                <p class="theme_color fontSize">SFI’s purpose is to help organizations go Beyond Compliance by improving lives, strengthening safety cultures, and empowering America’s workforce to return home safely each day. Through training, consulting, and practical safety management solutions, we work to reduce risk, prevent injuries, and create safer workplaces.</p>

                <p class="theme_color fontSize">
                    SFI provides safety expertise to leading companies and government agencies throughout the United States. Our success is built on strong client partnerships, effective communication, and proactive safety systems designed to create measurable improvement. We help our clients move beyond simply meeting requirements by building accountability, consistency, and long-term safety performance.
                </p>

                <p class="theme_color fontSize">
                    <strong>Our core values guide everything we do:</strong>
                </p>

                <ul class="theme_color fontSize">
                    <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-check-circle fontRed"></i>&nbsp;Purposeful & Positive</li>
                    <li data-aos="fade-up" data-aos-delay="200"><i class="fa fa-check-circle fontRed"></i>&nbsp;Unwavering Commitment to Our Customers</li>
                    <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-check-circle fontRed"></i>&nbsp;Ethically Driven</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-check-circle fontRed"></i>&nbsp;Continuous Improvement</li>
                    <li data-aos="fade-up" data-aos-delay="500"><i class="fa fa-check-circle fontRed"></i>&nbsp;Employee Focused Work Culture</li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section style="background-color: #F2F3F5;">
    <div class="container">
        <div class="row">
            <div class="col-lg-8" data-aos="fade-up" data-aos-delay="100" style="margin-top: 10px;">
                <h2 class="theme_color">
                    <strong>Beyond Compliance Safety Services</strong>.
                </h2>
                <h5 class="theme_color" style="font-weight: 600;">
                    From the boardroom to the jobsite, our team works alongside yours.
                </h5>

                <p class="theme_color fontSize">SFI is a full-service, bilingual safety consulting firm focused on helping organizations go Beyond Compliance. We assess existing safety programs, develop and refine written policies, provide safety and regulatory training, support OSHA recordkeeping, and deliver practical safety solutions tailored to your operation. <strong class="theme_color">We specialize in:</strong></p>

                <ul class="theme_color fontSize">
                    <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-check-circle fontRed"></i>&nbsp;Multi-Family Residential (Apartments)</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-check-circle fontRed"></i>&nbsp;Home Building – Single Family and Multi-Family</li>
                    <li data-aos="fade-up" data-aos-delay="500"><i class="fa fa-check-circle fontRed"></i>&nbsp;Commercial Construction</li>
                    <li data-aos="fade-up" data-aos-delay="600"><i class="fa fa-check-circle fontRed"></i>&nbsp;Heavy Highway Construction</li>                    
                    <li data-aos="fade-up" data-aos-delay="700"><i class="fa fa-check-circle fontRed"></i>&nbsp;Manufacturing</li>
                    <li data-aos="fade-up" data-aos-delay="800"><i class="fa fa-check-circle fontRed"></i>&nbsp;General Industry</li>
                </ul>
                <p></p>

                <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="800">
                    Our services are designed to go beyond simply meeting regulatory requirements. We provide risk management support, coordinate with insurance carriers and brokers, and assist clients during OSHA inspections and regulatory matters. Our goal is to help clients strengthen safety systems, reduce risk, improve accountability, and create measurable, lasting safety performance.
                </p>
                <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="900">
                    Clients rely on SFI for jobsite safety evaluations, ongoing consulting, toolbox talks, safety meetings, training, and proactive safety support. Our customized service programs are built around each client’s operations, workforce, and project needs—helping make safety a consistent part of how work gets done every day.
                </p>
            </div>
            <div class="col-lg-4 order-first order-md-last" data-aos="fade-up" data-aos-delay="100" style="margin-top: 10px;">
                <img  src="../../assets/images/about-02.png" class="img-fluid"  alt=""/>
            </div>
        </div>
    </div>
</section>

<section style="padding-bottom: 0%;">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12 text_align_center padding_0" data-aos="fade-up" data-aos-delay="100">
                <div class="full">
                    <img class="img-fluid" src="../../assets/images/about-03.jpg" alt="#" />
                </div>
            </div>
            <h2 class="theme_color">
                <strong>Safety Training that is Built on Excellence</strong>.
            </h2>
            <div class="col-lg-6 col-md-12 layout_padding padding_left_right" data-aos="fade-up" data-aos-delay="100">
                <p class="theme_color fontSize">Our qualified and authorized instructors provide safety training for construction and general industry clients. Courses are available in both English and Spanish and are designed to go Beyond Compliance by building practical knowledge, strengthening safe work practices, and helping employees apply what they learn in the field.<br/><br/> <strong class="theme_color">Our training programs include:</strong></p>
                <ul class="theme_color fontSize">
                    <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-check-circle fontRed"></i>&nbsp;Accident Investigation</li>
                    <li data-aos="fade-up" data-aos-delay="200"><i class="fa fa-check-circle fontRed"></i>&nbsp;Control of Workers Compensation Costs and Liability</li>
                    <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-check-circle fontRed"></i>&nbsp;OSHA 10-hour and OSHA 30-hour for Construction</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-check-circle fontRed"></i>&nbsp;OSHA 10-hour and OSHA 30-hour for General Industry</li>
                    <li data-aos="fade-up" data-aos-delay="500"><i class="fa fa-check-circle fontRed"></i>&nbsp;CPR / First Aid Training and AED Certification</li>
                    <li data-aos="fade-up" data-aos-delay="600"><i class="fa fa-check-circle fontRed"></i>&nbsp;Fall Protection</li>
                    <li data-aos="fade-up" data-aos-delay="700"><i class="fa fa-check-circle fontRed"></i>&nbsp;Scaffolding Safety Training</li>
                    <li data-aos="fade-up" data-aos-delay="800"><i class="fa fa-check-circle fontRed"></i>&nbsp;And many more</li>
                </ul>
            </div>
        </div>
    </div>    
</section>